import { createFileRoute } from "@tanstack/react-router";

import { RespiteDashboard } from "../tools/dashboards/RespiteDashboard";

function RespiteRoute() {
  return <RespiteDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/respite")({
  component: RespiteRoute,
});
